import React from 'react';
import classNames from 'classnames';

import { Icon, IconSymbol } from 'elements';

interface PillButtonProps {
  label: string;
  onClick: () => void;
  isSelected?: boolean;
  isDisabled?: boolean;
  className?: string;
  ariaLabel?: string;
  iconName?: IconSymbol;
  iconZoom?: string;
}

export const PillButton: React.FC<PillButtonProps> = ({
  label,
  onClick,
  isSelected = false,
  isDisabled = false,
  iconName,
  iconZoom,
  className = '',
  ariaLabel = '',
}) => {
  return (
    <button
      className={classNames(
        'pill-button',
        {
          'pill-button-selected': isSelected,
          'pill-button-disabled': isDisabled,
        },
        className
      )}
      onClick={onClick}
      disabled={isDisabled}
      aria-label={ariaLabel}
    >
      {iconName && (
        <Icon className='pill-button-icon' name={iconName} zoom={iconZoom} />
      )}
      {label}
    </button>
  );
};
